import { Controller, useForm } from 'react-hook-form';
import React, { useEffect } from 'react'
import { Button, MenuItem } from '@mui/material';
import { Select } from '@mui/material';
import { useGetChannelConnections } from 'hooks/useGetChannelConnections';
import { useDispatch } from 'react-redux';
import { updateChatSettingsAction } from 'redux/reducers/appLayout';

interface ChatSettingsFormProps {
    chatSettings: any;
    onClose: () => void;
}
export const ChatSettingsForm = ({ chatSettings, onClose }: ChatSettingsFormProps) => {
    const dispatch = useDispatch();

    // Form
    const { handleSubmit, control, watch, setValue, getValues } = useForm({
        defaultValues: {
            source: chatSettings?.source || "INSTAGRAM",
            externalAccountUserName: chatSettings?.externalAccountUserName || "",
        },
        mode: "onChange",
    });

    const { data: channelConnections } = useGetChannelConnections();

    // Аккаунты выбранного канала
    const source = watch("source");
    const accounts = channelConnections?.filter((channelConnection: any) => channelConnection.source === source) || [];

    // Если аккаунт один — выбираем его по умолчанию.
    // Если выбранного аккаунта нет в списке (например, сменили канал) — сбрасываем выбор.
    useEffect(() => {
        if (!channelConnections) return;
        const current = getValues("externalAccountUserName");
        const userNames = accounts.map((account: any) => account.externalAccountUserName);
        if (userNames.includes(current)) return;
        setValue("externalAccountUserName", userNames.length === 1 ? userNames[0] : "");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [channelConnections, source]);

    // On submit
    const onSubmit = (formData: any) => {
        dispatch(updateChatSettingsAction({
            orgID: localStorage.getItem("orgID") as string,
            source: formData.source,
            externalAccountUserName: formData.externalAccountUserName,
        }));
        onClose();
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-2">
            {/* Channel types as select  */}
            <Controller control={control} name="source" render={({ field }) => (
                <Select {...field} fullWidth>
                    <MenuItem value="WHATSAPP">WhatsApp</MenuItem>
                    <MenuItem value="TELEGRAM">Telegram</MenuItem>
                    <MenuItem value="INSTAGRAM">Instagram</MenuItem>
                </Select>
            )} />

            {/* User accounts */}
            <Controller control={control} name="externalAccountUserName" render={({ field }) => (
                <Select {...field} fullWidth>
                    {accounts.map((channelConnection: any) => (
                        <MenuItem key={channelConnection.id} value={channelConnection.externalAccountUserName}>
                            {channelConnection.externalAccountUserName}
                        </MenuItem>
                    ))}
                </Select>
            )} />

            {/* Save button */}
            <Button variant="contained" color="primary" fullWidth type="submit">Применить</Button>
        </form>

    )
}
